export default __webpack_public_path__ + "518b8d557bd928f95b585e66c560ba11.png";